// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboard_modal__FxBTt {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
  padding: 32px 24px;
  z-index: 1000;
  min-width: 320px;
  text-align: center;
}

.onboard_button__-Rbmm {
  background: #635bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  margin: 0 8px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.2s;
}
.onboard_button__-Rbmm:hover:not(:disabled) {
  background: #4b42d6;
}
.onboard_button__-Rbmm:disabled {
  background: #bdbdbd;
  cursor: not-allowed;
}

.onboard_error__JJMVF {
  color: #d32f2f;
  background: #fff0f0;
  border: 1px solid #f8d7da;
  border-radius: 4px;
  padding: 8px 12px;
  margin-top: 12px;
  font-size: 15px;
  text-align: center;
}

.onboard_addBtn_stl__RkPhu {
  height: 48px;
}

@media (max-width: 1400px) {
  .onboard_addBtn_stl__RkPhu {
    padding: 16px 18px 15px 19px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Onboard/onboard.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;AACF;AAAE;EACE,mBAAA;AAEJ;AAAE;EACE,mBAAA;EACA,mBAAA;AAEJ;;AAEA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAGA;EACE;IACE,4BAAA;EAAF;AACF","sourcesContent":[".modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: #fff;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.12);\n  padding: 32px 24px;\n  z-index: 1000;\n  min-width: 320px;\n  text-align: center;\n}\n\n.button {\n  background: #635bff;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  padding: 10px 20px;\n  margin: 0 8px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background 0.2s;\n  &:hover:not(:disabled) {\n    background: #4b42d6;\n  }\n  &:disabled {\n    background: #bdbdbd;\n    cursor: not-allowed;\n  }\n}\n\n.error {\n  color: #d32f2f;\n  background: #fff0f0;\n  border: 1px solid #f8d7da;\n  border-radius: 4px;\n  padding: 8px 12px;\n  margin-top: 12px;\n  font-size: 15px;\n  text-align: center;\n} \n\n.addBtn_stl {\n  height: 48px;\n}\n\n\n@media (max-width: 1400px) {\n  .addBtn_stl {\n    padding: 16px 18px 15px 19px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `onboard_modal__FxBTt`,
	"button": `onboard_button__-Rbmm`,
	"error": `onboard_error__JJMVF`,
	"addBtn_stl": `onboard_addBtn_stl__RkPhu`
};
export default ___CSS_LOADER_EXPORT___;
